import atendimentoRapidoService from '../services/atendimentoRapido.service'
import lodash from 'lodash'

const {
	getAtendimentosFundacao,
	createAtendimentoRapido: createAtendimentoRapidoService,
} = atendimentoRapidoService()

export default {
	name: 'AtendimentoRapidoMixin',
	data() {
		return {
			isLoadingAtendimentoRapido: false,
			listaClientesAtendimentoRapido: [],
		}
	},

	methods: {
		addClienteAtendimentoRapido(clienteId) {
			this.listaClientesAtendimentoRapido.push(clienteId)
			this.listaClientesAtendimentoRapido = lodash.uniq(
				this.listaClientesAtendimentoRapido
			)
		},

		removeClienteAtendimentoRapido(clienteId) {
			this.listaClientesAtendimentoRapido =
				this.listaClientesAtendimentoRapido.filter(
					(itemClienteId) => itemClienteId !== clienteId
				)
		},

		clearClienteAtendimentoRapido() {
			this.listaClientesAtendimentoRapido = []
		},

		async createAtendimentoRapido(
			tipoAtendimentoRapido,
			menssagemAtendimentoRapido,
			tituloAtendimento = null,
			dataAtendimento = null
		) {
			try {
				this.isLoadingAtendimentoRapido = true

				const { atendimentos } = await getAtendimentosFundacao(
					this.listaClientesAtendimentoRapido
				)

				const dataAtedimentoComum = atendimentos.reduce(
					(acumuladorAtendimento, itemAtendimento) => {
						acumuladorAtendimento.fundacoesId.push(itemAtendimento.id)
						acumuladorAtendimento.fundacoesData.push(
							itemAtendimento.atendimento_data || new Date().toISOString()
						)

						return acumuladorAtendimento
					},
					{ fundacoesId: [], fundacoesData: [] }
				)

				const formDataAtendimentoRapido = {
					fundacoes_ids: dataAtedimentoComum.fundacoesId,
					tipo_atendimento: tipoAtendimentoRapido,
					atendimento: menssagemAtendimentoRapido,
					notificacao: '2',
					data: dataAtendimento
						? dataAtendimento
						: dataAtedimentoComum.fundacoesData,
					data_atendimento: new Date().toISOString(),
					titulo_atendimento: tituloAtendimento,
				}
				const responseAtividadeRapida = await createAtendimentoRapidoService(
					formDataAtendimentoRapido
				)

				this.clearClienteAtendimentoRapido()
				GLOBAL.showToastify('✅ Atendimento(s) criado com sucesso.')
				return responseAtividadeRapida
			} catch (e) {
				console.log(e)
			} finally {
				this.isLoadingAtendimentoRapido = false
			}
		},
	},
}
